import { getTenantInfo } from "../../utils/domain";

export const User = (store) => {
  return store.getState().user;
};

/******** Routing authentication middleware ***********/
export const Auth = (store) => {
  // return false;
  return User(store).loggedIn;
};

/******** Set Authorization token in header ***********/
export const setAuthorizationToken = (axios) => {
  let token = localStorage.getItem("token");
  axios.defaults.withCredentials = false;
  if (token) {
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common.Authorization;
  }

  const tenantInfo = getTenantInfo();
  if (tenantInfo?.slug) {
    axios.defaults.headers.common["x-tenant-slug"] = tenantInfo.slug;
    axios.defaults.headers.common["x-tenant-portal"] = tenantInfo.portalType || "admin";
    if (tenantInfo.hostname) {
      axios.defaults.headers.common["x-tenant-domain"] = tenantInfo.hostname;
    }
  } else {
    delete axios.defaults.headers.common["x-tenant-slug"];
    delete axios.defaults.headers.common["x-tenant-portal"];
    delete axios.defaults.headers.common["x-tenant-domain"];
  }
};

